import { ref } from 'vue'

// Bumped whenever server-side data changes, so mounted KPI consumers (dashboard tiles and the
// contextual signal bar) refetch. Kept in a leaf module — no api/store imports — so the axios
// interceptor can trigger it without an import cycle.
export const kpiVersion = ref(0)

const cacheClearers = new Set()

export const registerKpiCacheClearer = (clear) => { cacheClearers.add(clear) }

export const invalidateKpis = () => {
  cacheClearers.forEach(clear => clear())
  kpiVersion.value++
}
